import { render, staticRenderFns } from "./role-management.vue?vue&type=template&id=d43d9484&"
import script from "./role-management.vue?vue&type=script&lang=js&"
export * from "./role-management.vue?vue&type=script&lang=js&"
import style0 from "./role-management.vue?vue&type=style&index=0&id=d43d9484&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports